module.exports = __webpack_public_path__ + "static/traffic-9fa679d7961846fb73a3319f904f5a0d.jpg";